var firebase = require('firebase');

const config = {
	apiKey: "AIzaSyD2YaT4s3UQj8M267Gy5J4qRXqSDqZL8Uo",
	authDomain: "holidayparty-21ef5.firebaseapp.com",
	databaseURL: "https://holidayparty-21ef5.firebaseio.com",
	projectId: "holidayparty-21ef5",
	storageBucket: "holidayparty-21ef5.appspot.com",
	messagingSenderId: "1002544602258",
	appId: "1:1002544602258:web:e25e0c08a2beb506bf1a4b",
	measurementId: "G-MMRMEDSJEQ"
 };

const firebaseApp = firebase.initializeApp(config);
let storage = firebaseApp.storage();
let storageRef = firebaseApp.storage().ref();
let database = firebase.database();

export {storage, storageRef, database};